var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.95023,
    y: 5.28226,
    width: 97.9355,
    height: 97.9355,
    rx: 48.9677,
    fill: "#8BF082"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.95023,
    y: 5.28226,
    width: 97.9355,
    height: 97.9355,
    rx: 48.9677,
    stroke: "#F0FDFA",
    strokeWidth: 9.93548
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 58.27L45.4414 69.7114L75.9028 39.25",
    stroke: "white",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.72228af45f83ea5dedf350f07fefd42b.svg";
export { ForwardRef as ReactComponent };